// src/pages/ProfilePage.js
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import DemonCard from "../components/DemonCard";
import "./ProfilePage.css";

export default function ProfilePage() {
  const { user, profile } = useAuth();
  const demon = profile?.demon;

  if (!user) return (
    <div className="profile-page section" style={{paddingTop:"8rem", textAlign:"center"}}>
      <span className="section-eyebrow">Accès refusé</span>
      <h2 className="section-title">Tu n'es pas encore<br/>dans le registre</h2>
      <div className="divider divider-center"/>
      <Link to="/auth" className="btn btn-primary" style={{marginTop:"1rem"}}>ENTRER →</Link>
    </div>
  );

  return (
    <div className="profile-page">
      <div className="section" style={{paddingTop:"7rem"}}>
        <div className="profile-header">
          <div>
            <span className="section-eyebrow">Profil · 鬼</span>
            <h1 className="section-title">
              {profile?.displayName || user.displayName || "Oni Inconnu"}
            </h1>
          </div>
          {demon && (
            <span className="badge badge-blood" style={{alignSelf:"flex-start", marginTop:"0.5rem"}}>
              {demon.oni?.name || "—"}
            </span>
          )}
        </div>
        <div className="divider"/>

        {demon ? (
          <div className="profile-content">
            <DemonCard demon={demon} />
            <div className="profile-actions">
              <Link to="/awaken" className="btn btn-ghost btn-sm">REFAIRE LE QUIZ ↺</Link>
              <Link to="/coach" className="btn btn-primary btn-sm">COACH DÉMONIAQUE →</Link>
            </div>
          </div>
        ) : (
          <div className="no-demon">
            <p className="no-demon-emoji">👹</p>
            <p>Ton démon n'est pas encore apparu.</p>
            <Link to="/awaken" className="btn btn-primary" style={{marginTop:"1.5rem"}}>
              RÉVEILLER MON DÉMON →
            </Link>
          </div>
        )}
      </div>
    </div>
  );
}
